<template>
<div v-if="textOnly" class="flex flex-col text-neutral-800">
	<div v-if="displayLabels" class="font-bold" v-text="label"/>
	<div v-text="`Dane uzupełnione w ${Math.round(percentageValue)}%`"/>
</div>
<div v-else class="flex flex-col gap-2">
	<div v-if="!displaySteps" class="relative h-2 rounded-full bg-accent-100">
		<div class="absolute inset-0 rounded-full bg-accent" :style="{ width: `${percentageValue}%` }"/>
	</div>
	<div v-else class="flex gap-1">
		<div v-for="i in max" :key="i" class="h-2 grow rounded-full" :class="barColor(i)"/>
	</div>
	<div v-if="displayLabels" class="flex justify-between text-body-sm text-neutral-600">
		<div v-text="`Dane uzupełnione w ${Math.round(percentageValue)}%`"/>
		<div class="font-bold text-right" v-text="label"/>
	</div>
</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface OProgressBarProps {
	/** Czy pokazać liczbę kroków? W innym przypadku, wyświetl wartość procentową" */
	displaySteps?: boolean;
	/** Czy pokazać labelki pod paskiem postępu? */
	displayLabels?: boolean;
	/** Liczba wszystkich kroków */
	max: number;
	/** Krok, na którym obecnie się znajdujemy */
	activeStep?: number;
	/** Treść labelki w zależności od postępu */
	labels?: [number, string][];
	/** Czy wyświetlać tylko etykietki? */
	textOnly?: boolean;
}

const modelValue = defineModel<number>();

const props = withDefaults(
	defineProps<OProgressBarProps>(),
	{
		displaySteps: false,
		displayLabels: true,
		activeStep: -1,
		labels: () => ([
			[0, 'Zaczynamy!'],
			[25, 'Dobra robota!'],
			[50, 'Tak trzymaj!'],
			[75, 'Jeszcze ostatni krok!'],
			[100, 'Gotowe!'],
		]),
	},
);

const percentageValue = computed(() => {
	return Math.min((modelValue.value || 0) * (100 / props.max), 100);
});

const label = computed(() => {
	const result = props.labels.findLast((el) => el[0] <= (percentageValue.value || 0));
	return result ? result[1] : '';
});

function barColor(i: number) {
	if (i === props.activeStep) { return 'bg-accent-200'; }
	return i <= (modelValue.value || 0) ? 'bg-accent' : 'bg-accent-100';
}

</script>
